// frontend/src/components/LandingPage.js
import React, { useState } from 'react';
import '../styles/LandingPage.css';
import ChatAssistant from './ChatAssistant';

const LandingPage = () => {
  const [showChat, setShowChat] = useState(false);
  const [chatFailed, setChatFailed] = useState(false);

  const handleChatLoad = () => {
    setShowChat(true);

    // Simulate chatbot failure after 5 seconds (optional logic)
    setTimeout(() => {
      if (!window.chatInitiated) {
        setChatFailed(true);
      }
    }, 5000);
  };

  return (
    <div className="landing-container">
      <h1>Find Out What You Qualify For — Fast & Free</h1>
      <p>Talk to our AI loan assistant in seconds. No credit pull required.</p>

      {!showChat && (
        <button className="start-chat-button" onClick={handleChatLoad}>
          Start Chat Now
        </button>
      )}

      {showChat && (
        <div className="chat-container">
          <ChatAssistant />
        </div>
      )}

      {chatFailed && (
        <div className="fallback-form">
          <h3>Having trouble with the chat?</h3>
          <form method="POST" action="https://homeleadiq.onrender.com/api/leads">
            <input type="text" name="name" placeholder="Your Name" required />
            <input type="email" name="email" placeholder="Your Email" required />
            <input type="tel" name="phone" placeholder="Your Phone" required />
            <button type="submit">Submit Info</button>
          </form>
        </div>
      )}
    </div>
  );
};

export default LandingPage;